var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _vm.$config.unauthorizedMessage
      ? _c("p", {
          domProps: { innerHTML: _vm._s(_vm.$config.unauthorizedMessage) }
        })
      : _c("p", [
          _vm._v(
            "Unfortunately, we could not detect session data for your account."
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }